import React from "react";

const DocumentSvgIcon = ({ width = 24, height = 24, className }) => {
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="clip0_2733_4421">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
        <g clipPath="url(#clip0_2733_4421)">
          <path
            d="M6.00003 0C5.17503 0 4.50003 0.675 4.50003 1.5V22.5C4.50003 23.325 5.17503 24 6.00003 24H21C21.825 24 22.5 23.325 22.5 22.5V6L16.5 0H6.00003Z"
            fill="#E2E5E7"
          />
          <path
            d="M18 6H22.5L16.5 0V4.5C16.5 5.325 17.175 6 18 6Z"
            fill="#B0B7BD"
          />
          <path d="M22.5 10.5L18 6H22.5V10.5Z" fill="#CAD1D8" />
          <path
            d="M19.5 19.5C19.5 19.9125 19.1625 20.25 18.75 20.25H2.25003C1.83753 20.25 1.50003 19.9125 1.50003 19.5V12C1.50003 11.5875 1.83753 11.25 2.25003 11.25H18.75C19.1625 11.25 19.5 11.5875 19.5 12V19.5Z"
            fill="#F15642"
          />
          <path
            d="M4.76926 14.2101C4.76926 14.0121 4.92526 13.7961 5.17651 13.7961H6.56176C7.34176 13.7961 8.04376 14.3181 8.04376 15.3186C8.04376 16.2666 7.34176 16.7946 6.56176 16.7946H5.56051V17.5866C5.56051 17.8506 5.39251 17.9999 5.17651 17.9999C4.97851 17.9999 4.76926 17.8506 4.76926 17.5866V14.2101ZM5.56051 14.5514V16.0454H6.56176C6.96376 16.0454 7.28176 15.6906 7.28176 15.3186C7.28176 14.8994 6.96376 14.5514 6.56176 14.5514H5.56051ZM9.21826 17.9999C9.02026 17.9999 8.80426 17.8919 8.80426 17.6286V14.2221C8.80426 14.0069 9.02026 13.8501 9.21826 13.8501H10.5915C13.332 13.8501 13.272 17.9999 10.6455 17.9999H9.21826ZM9.59626 14.5821V17.2686H10.5915C12.2108 17.2686 12.2828 14.5821 10.5915 14.5821H9.59626ZM14.244 14.6301V15.5834H15.7733C15.9893 15.5834 16.2053 15.7994 16.2053 16.0086C16.2053 16.2066 15.9893 16.3686 15.7733 16.3686H14.244V17.6279C14.244 17.8379 14.0948 17.9991 13.8848 17.9991C13.6208 17.9991 13.4595 17.8379 13.4595 17.6279V14.2214C13.4595 14.0061 13.6215 13.8494 13.8848 13.8494H15.99C16.254 13.8494 16.41 14.0061 16.41 14.2214C16.41 14.4134 16.254 14.6294 15.99 14.6294H14.244V14.6301Z"
            fill="white"
          />
          <path
            d="M18.75 20.25H4.50003V21H18.75C19.1625 21 19.5 20.6625 19.5 20.25V19.5C19.5 19.9125 19.1625 20.25 18.75 20.25Z"
            fill="#CAD1D8"
          />
        </g>
      </svg>
    </div>
  );
};

export default DocumentSvgIcon;
